//TODO: remove these eslint rules once testing related things are removed (consoles, variables)
export default {
  state: {
    domain_based_brand: undefined,
    domain: 'goorder', //it can be web
    current_brand: undefined,
    is_store_brand: false,
    delivery_area: undefined,
  },
  mutations: {
    SET_CURRENT_BRAND: (state, brand) => {
      state.current_brand = brand
    },
    IS_STORE_BRAND: (state, is_store_brand) => {
      state.is_store_brand = is_store_brand
    },

    SET_DELIVERY_AREA: (state, delivery_area) => {
      let type_of = typeof delivery_area
      if (delivery_area.length) {
        if (type_of === Array || type_of === 'object') {
          state.delivery_area = delivery_area[0].name
        } else {
          state.delivery_area = delivery_area
        }
      } else state.delivery_area = undefined
    },

    SET_DOMAIN_BASED_BRAND: (state, domain_brand) => {
      state.domain_based_brand = domain_brand
      if (domain_brand) {
        state.domain = 'web'
      }
    },
    SET_ONESIGNAL_SDK: (state, domain_brand) => {
      let appID = process.env.VUE_APP_ONESIGNAL
      let appSafariID = process.env.VUE_APP_ONESIGNAL_SAFARI
      if (domain_brand) {
        appID = domain_brand.onesignal_app_id
        appSafariID = domain_brand.onesignal_safari_app_id
      }
      window.OneSignal.push(() => {
        window.OneSignal.init({
          appId: appID,
          safari_web_id: appSafariID,
          notifyButton: {
            enable: true,
          },
        })
      })
    },
  },
  actions: {
    initializeContext: ({ state, commit, dispatch, getters }) => {
      commit('START_SETTING_CONTEXT')
      return new Promise((resolve, reject) => {
        var domain_based_brand = state.current_brand
        if (
          !domain_based_brand &&
          process.env.NODE_ENV === 'development' &&
          process.env.VUE_APP_LOCAL_WEBSITE
        ) {
          //brandwebsite.local|urbanseastglatest.goclient.name
          const [
            localWebsite,
            onlineWebsite,
          ] = process.env.VUE_APP_LOCAL_WEBSITE.split('|')
          if (location.hostname == localWebsite && onlineWebsite) {
            domain_based_brand = getters.all_brands.find(
              item => item.hostname == onlineWebsite
            )
          }
        }
        let pwa_logo_link = 'images/goorder_logo.png'
        if (domain_based_brand) {
          // commit('SET_DOMAIN_BASED_BRAND', domain_based_brand._id)
          // commit('SET_DOMAIN_BASED_COLORS', domain_based_brand)
          // commit('SET_DOMAIN_BASED_CUSTOM_SETTINGS', domain_based_brand)
          // commit('SET_ONESIGNAL_SDK', domain_based_brand)
          // dispatch('setCustomSettings') //--here
          pwa_logo_link = domain_based_brand.pwa_logo
          dispatch('load_brand_web_translations').then(() => {
            dispatch('load_brand_website_banners').then(() => {
              resolve()
            })
          })
          commit('FINISH_SETTING_CONTEXT')
        } else {
          commit('SET_DOMAIN_BASED_BRAND', undefined)
          commit('SET_DOMAIN_BASED_COLORS', undefined)
          commit('SET_DOMAIN_BASED_CUSTOM_SETTINGS', undefined)
          commit('SET_ONESIGNAL_SDK', undefined)
          resolve()
        }
        var pwa_apple_elems = document.getElementsByClassName('pwimage')
        for (var i = 0; i < pwa_apple_elems.length; i++) {
          pwa_apple_elems.item(i).setAttribute('href', pwa_logo_link)
        }
        // })
      })
    },

    // updateCurrency: ({ getters, dispatch }) => {
    //   let utcMoment = moment.utc()
    //   let current_utc_time = new Date(utcMoment.format())
    //   current_utc_time.valueOf()
    //   /*currency_duration: "00:30"
    //         currency_last_updated: "2020-11-22 02:30:02"*/
    //   let currency_last_updated = getters.get_settings.currency_last_updated
    //   let currency_duration = getters.get_settings.currency_duration
    //   // will add both above
    //   /*var d = new Date();
    //         var n = d.getUTCDate();*/
    //   let g1 = new Date(current_utc_time)
    //   // (YYYY-MM-DD)
    //   let g2 = new Date(currency_last_updated)
    //   if (g1.getTime() < g2.getTime()) {
    //     console.log(g1.getTime(), g2.getTime(), 'g1.getTime()')
    //     dispatch('load_currencies')
    //   }
    // },
    updateExternalHandler: ({ getters }, handlerCall) => {
      if (localStorage.getItem('isWedView')) {
        window.location = handlerCall
      }
    },
  },
  getters: {
    set_website_slug: () => data => {
      let slug = data ? data.website_slug : ''
      if (slug) {
        // if (slug.indexOf('')) {
        let remove_underscore = slug.toLowerCase().replace(/_/g, '-')
        return remove_underscore.replace(/ /g, '-')
        // } return slug.toLowerCase()
      }
    },
    siteDomain: state => state.domain,
    isStoreBrand: state => state.is_store_brand,

    currentBrandId: state =>
      state.current_brand ? state.current_brand._id : undefined,
    currentBrandSlug: (state, getters) =>
      state.current_brand
        ? getters.set_website_slug(state.current_brand)
        : undefined,
    currentDeliveryArea: (state, getters) => {
      let url_name = getters.set_website_slug({
        website_slug: state.delivery_area,
      })
      return url_name
    },
    currentBrand: state => state.current_brand,
    isModuleEnable: (state, getters) => module => {
      if (getters.domainBasedBrand) {
        return state.current_brand.enabled_modules.find(active_module => {
          if (active_module === module) return true
        })
      } else {
        if (getters.all_goorder_settings[0]) {
          return getters.all_goorder_settings[0][module.toLowerCase()]
        } else {
          return false
        }
      }
    },

    findTimezoneByStore: (state, getters) => store =>
      store ? getters.find_timezone_by_main_id(store.timezone) : {},
    domainBasedBrand: state => state.domain_based_brand,
    goorder: state => typeof state.domain_based_brand === 'undefined',
    brandStoreParams: (state, getters) =>
      getters.domainBasedBrand
        ? {
            store_id:
              getters.currentStoreSlug || getters.cart_brand_store.store_id,
          }
        : {
            brand_id:
              getters.currentBrandSlug || getters.cart_brand_store.brand_id,
            store_id:
              getters.currentStoreSlug || getters.cart_brand_store.store_id,
          },
    brandStoreRoute: (state, getters) => routeName =>
      getters.domainBasedBrand ? 'brand_' + routeName : 'goorder_' + routeName,
  },
}
